import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { FormExtraOptions } from '../../../../../molecules/formExtraOptions';
import { useJobTitleFilter } from './useJobTitleFilter';

export const JobTitleFilter = ({ value, setFilters, sharedList, orderBy, jobTitlesIncluded }) => {
  const { formSchema, onSearchChange, onSubmit, jobTitleIncludedOptions } = useJobTitleFilter({
    sharedList,
    orderBy,
    setFilters,
  });

  return (
    <Formik
      initialValues={{ jobTitles: value || [], jobTitlesIncluded: jobTitlesIncluded || jobTitleIncludedOptions[0] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Field
            name="jobTitles"
            label="Job title"
            placeholder="Select or press enter"
            size="small"
            component={FormAsyncMultiSelect}
            loadOptions={onSearchChange}
            formatCreateLabel={(inputValue) => `Press 'enter' to add ${inputValue}`}
            isValidNewOption={(inputValue) => Boolean(inputValue?.trim())}
            isCreatable
            anchorToBody
            allowCreateWhileLoading
          />
          <Field
            name="jobTitlesIncluded"
            placeholder="Current"
            component={FormExtraOptions}
            options={jobTitleIncludedOptions}
            anchorToBody
          />
          <span style={{ fontSize: '12px', color: 'text.subtle' }}>
            Learn to use boolean searches{' '}
            <a
              href="https://help.getro.com/support/solutions/articles/65000188936-how-to-use-boolean-searches-to-find-contacts"
              target="_blank"
              rel="noreferrer"
            >
              here
            </a>
            .
          </span>
        </div>
      </Form>
    </Formik>
  );
};

JobTitleFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  sharedList: PropTypes.object,
  orderBy: PropTypes.oneOf(['count', 'alpha']),
  jobTitlesIncluded: PropTypes.object,
};

JobTitleFilter.defaultProps = {
  value: [],
  sharedList: null,
  orderBy: 'count',
  jobTitlesIncluded: null,
};
